<div class="card" [class.-active]="active" [attr.productId]="lamp.productId">
  <img alt="lamp-img" *ngIf="isValidImage" class="image" [attr.src]="lamp.image | async" (error)="setDefaultImage()" />
  <div *ngIf="!isValidImage" class="default-image">
    <span class="fa fa-picture-o fa-2x"></span>
    <label class="default-image-label">{{ 'module.energyMap.lampCard.noPictureText' | translate }}</label>
  </div>
  <div class="content">
    <div class="row-section">
      <div class="value-group">
        <h5 class="value price">{{ productPrice | number: '1.0-0' : 'es' }} €</h5>
        <label class="label">{{ priceLabel }}</label>
      </div>
      <div class="value-group" *ngIf="count > 0">
        <h5 class="value price">{{ count | number: '' : 'es' }}</h5>
        <label class="label">{{ 'module.energyMap.lampCard.numberText' | translate }} </label>
      </div>
    </div>

    <div class="value-group">
      <h4 class="model">{{ lamp.suggestedModel }}</h4>
      <h5 class="consumption">Energieverbrauch: ca. {{ lamp.energySavings | number: '1.0-0' : 'es' }} kWh/a</h5>
    </div>
  </div>
  <div class="actions">
    <button class="btn btn-outline-primary" (click)="select(lamp)">{{ 'module.energyMap.lampCard.selectButtonText' | translate }}</button>
  </div>
</div>
